import React from 'react';
import { Link } from 'react-router-dom';
import * as moment from "moment";
import { Badge } from 'reactstrap';

const formateDate = (date, format) => {
    const dateFormat = format ? format : "LLL";
    const date1 = moment(new Date(date)).format(dateFormat);
    return date1;
};
const toLowerCase1 = str => {
    return (
      str === "" || str === undefined ? "" : str.toLowerCase()
    );
  };


const BillingName = (cell) => {
    return cell.value ? cell.value : '';
};

const Date = (cell) => {
    return (cell.value) ? moment(cell.value).format('YYYY-MM-DD') : '';
};

const Total = (cell) => {
    return cell.value ? moment(cell.value).format('MMMM Do YYYY, h:mm:ss a') : '';
};

const PaymentStatus = (cell) => {
    return cell.value ? cell.value : '';
};
const PaymentMethod = (cell) => {
    return cell.value ? cell.value : '';
};
export {
    // OrderId,
    BillingName,
    Date,
    Total,
    PaymentStatus,
    PaymentMethod
};